import { render, staticRenderFns } from "./AddToGroupDialog.vue?vue&type=template&id=4c2ed950&scoped=true"
import script from "./AddToGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddToGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddToGroupDialog.vue?vue&type=style&index=0&id=4c2ed950&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ed950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2ed950')) {
      api.createRecord('4c2ed950', component.options)
    } else {
      api.reload('4c2ed950', component.options)
    }
    module.hot.accept("./AddToGroupDialog.vue?vue&type=template&id=4c2ed950&scoped=true", function () {
      api.rerender('4c2ed950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/AddToGroupDialog.vue"
export default component.exports